import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const HEALTH_NAV_ITEMS = [
  { name: 'Overview', path: '/health' },
  { name: 'Principles', path: '/health/principles' },
  { name: 'Sugar', path: '/health/sugar' },
  { name: 'By Age', path: '/health/by-age' },
  { name: 'Food & Nutrients', path: '/health/food' },
];

const HealthSubNav = () => {
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/health') return location.pathname === '/health';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="health-subnav">
      <div className="health-subnav-inner">
        {HEALTH_NAV_ITEMS.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`health-subnav-link ${isActive(item.path) ? 'active' : ''}`}
          >
            {item.name}
            {isActive(item.path) && (
              <motion.div
                layoutId="healthActiveLink"
                className="health-subnav-indicator"
                transition={{ type: 'spring', stiffness: 380, damping: 30 }}
              />
            )}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default HealthSubNav;
